import * as React from 'react'
import { Link } from 'react-router-dom'
import { FaCreditCard } from 'react-icons/fa'
import axios from '../../services/index'
import { UsernameContext } from '../../App'

//This component show the list of trainings to Admin with link to edit them
export const TrainingList: React.FunctionComponent = (props) => {

    const {currentUsername, setCurrentUsername} = React.useContext(UsernameContext)
    const currentToken = localStorage.getItem('access_token')
    const [trainingArray, setTrainingArray] = React.useState<Array<any>>([])


    React.useEffect(() => {
        axios.get('https://LaurenceBrun.eu.pythonanywhere.com/training/', {
            headers: {
                "Authorization" : `Bearer ${currentToken}`
            }
        })
        .then(function(response: any) {
            let requestTrainingArray = response.data.map((training: any) => {
                return {title: training.title, 
                        paidTraining: training.allowedUsers, 
                        id: training.id,
                        price: training.price}
            })
            setTrainingArray(requestTrainingArray)
        })
        .catch(function(error: any) {
            console.log(error)
            alert("Une erreur est survenue ! Veuillez réessayer")
        })
    },[])

    const deleteTraining = (trainingId: any) => {
        const validate = window.confirm('Êtes-vous sur de vouloir supprimer ?');
        if (validate) {
            axios.delete(`https://LaurenceBrun.eu.pythonanywhere.com/admintrainingadd/${trainingId}`, {
                headers: {
                    "Authorization": `Bearer ${currentToken}`
                }
            })
            .then((response) => {
                alert('Formation supprimée !')
                window.location.reload()
            })
            .catch((error) => {
                alert('Une erreur est survenue')
            })
        }
    }


    const tableRow = () => {
        return trainingArray.map((training: any) => {
                return (
                    <tr>
                        <td>{training.title}</td>
                        <td>{training.paidTraining.length}</td>
                        <td>{training.price} €</td>
                        <td><Link className="ConnectButton ConnexionSmall" to={`/admin/editTraining/${training.id}`}>Editer</Link>
                            <div className="ConnectButton ConnexionSmall" onClick={(()=>{deleteTraining(training.id)})}>Supprimer</div></td>
                        <td>{training.price === "1.00" ? <Link to={{pathname: currentUsername?`/training/${training.id}/buy`:"/connexion", state: currentUsername?{name: training.title, price: training.price}:{}}}><FaCreditCard className="TdIcon" size={25} /></Link> : <div></div>}</td>
                    </tr>
                )
        })
    }

    return(
        <div>
            <h2>Liste des formations</h2>
            <table>
                <thead>
                    <tr>
                        <th>Nom de la formation</th>
                        <th>Nombre d'achat</th>
                        <th>Prix actuel</th>
                        <th>Modifier Formation</th>
                        <th>Test achat</th>
                    </tr>
                </thead>
                <tbody>
                    {tableRow()}
                </tbody>
            </table>
        </div>
    )
}